import { useEffect } from 'react'
import { FaTimes } from 'react-icons/fa'
import Portal from './Portal'

const TooltipModal = ({
  isOpen,
  closeModal,
  title,
  content,
  confirmation,
  height,
  isConfirmDisabled,
  onConfirm,
  videoSrc,
}) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset'
  }, [isOpen])

  return (
    <Portal>
      <div
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            closeModal()
          }
        }}
        className={`fixed z-[110] top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center ${
          isOpen ? 'opacity-100' : 'opacity-0'
        } transition-opacity duration-200 ${
          isOpen ? 'pointer-events-auto' : 'pointer-events-none'
        }`}
      >
        <div
          className={`bg-[var(--middle-bg-color)] max-w-lg md:max-w-2xl m-4 md:m-12 overflow-hidden flex flex-col min-h-0 max-h-[85vh] rounded-lg shadow-2xl p-6 text-gray-100 space-y-4 relative transform transition-all duration-200 ${
            isOpen ? 'scale-100 opacity-100' : 'scale-70 opacity-0'
          } ${height ? 'h-3/4' : ''}`}
        >
          <header className="shrink-0">
            <h2 className="text-xl font-semibold text-shadow">{title}</h2>
            <button
              onClick={closeModal}
              className="absolute right-2 top-2 m-4 text-white"
              style={{ fontSize: '1.5rem' }}
            >
              <FaTimes />
            </button>
          </header>

          <main className="flex-1 min-h-0 overflow-y-auto flex flex-col space-y-4">
            {/* Video element */}
            <video
              className="rounded-md border border-gray-800 shadow-md object-cover mb-4"
              src={videoSrc} // <- Provide your video source here
              loop
              autoPlay
              muted
            />
            <div className="text-sm">{content}</div>
          </main>

          {confirmation && (
            <footer className="shrink-0">
              <button
                onClick={() => {
                  closeModal()
                  if (!isConfirmDisabled && onConfirm) {
                    onConfirm()
                  }
                }}
                className={`bg-white text-black rounded-full py-2 px-4 w-full font-semibold transition-colors duration-200 mt-6 
              ${isConfirmDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={isConfirmDisabled}
              >
                {confirmation}
              </button>
            </footer>
          )}
        </div>
      </div>
    </Portal>
  )
}

export default TooltipModal
